import { Box, makeStyles, Theme, Typography } from '@material-ui/core'
import MDTable from './MDTable'
import { FormattedMessage } from 'react-intl'
import { WarningCircleIcon } from '@src/icons'
import { useMaterialsDirectQuery } from '@src/queries/MaterialsDirectQuery.generated'
import ItemsSkeleton from '../ItemsSkeleton'
import ListError from '@src/components/ListError'
import OrderCenterLayout from '../OrderCenterLayout'

const useStyles = makeStyles((theme: Theme) => ({
  content: {
    paddingRight: theme.spacing(5),
    paddingLeft: theme.spacing(5),

    [theme.breakpoints.up('md')]: {
      padding: 0,
    },
  },
  title: {
    marginBottom: theme.spacing(2),
  },
  warning: {
    display: 'flex',
    gap: theme.spacing(2),
    fontWeight: 700,
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(8),

    '& svg': {
      fill: theme.palette.vibrant.yellow,
    },
  },
  error: {
    padding: theme.spacing(6, 4),

    [theme.breakpoints.up('md')]: {
      padding: 0,
    },
  },
}))

const MaterialsDirect = () => {
  const classes = useStyles()

  const { loading, error, data } = useMaterialsDirectQuery({
    variables: {
      input: {
        soldTo: '',
        shipToList: [''],
        contactParty: '',
        status: '',
        customerMaterialNo: '',
        lotNo: '',
        orderNo: '',
        poNo: '',
        page: 1,
        pageSize: 1,
      },
    },
    ssr: false,
  })

  return (
    <OrderCenterLayout isNavEnabled={false}>
      <Box className={classes.content}>
        <Box className={classes.title}>
          <Typography variant="h1">
            <FormattedMessage id="ORDERS" defaultMessage="Orders" />
          </Typography>
        </Box>

        <Typography variant="body1">
          <FormattedMessage
            id="REAL_TIME_UPDATES_TO_KEEP_YOU_INFORMED_ABOUT_THE_STATUS_OF_YOUR_ORDERS"
            defaultMessage="Real-time updates to keep you informed about the status of your orders."
          />
        </Typography>

        <Box className={classes.warning}>
          <WarningCircleIcon />
          <FormattedMessage
            id="ONLY_THE_LAST_6_MONTHS_OF_DATA_ARE_DISPLAYED_BELOW"
            defaultMessage="Only the last 6 months of data are displayed below."
          />
        </Box>

        {loading && <ItemsSkeleton />}
        {error && (
          <Box className={classes.error}>
            <ListError />
          </Box>
        )}
        {data && <MDTable data={data} />}
      </Box>
    </OrderCenterLayout>
  )
}

export default MaterialsDirect
